var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"guide__myguide-toggle",class:_vm.myguideClass,on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.isMyguide ? '-myguide' : '+myguide')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }